import { common } from './environment.common';

export const environment = {
  ...common,
  production: true
};
